// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shimmer-wrapper {
  width: 100%;
  border: 1px solid transparent;
}
.shimmer-wrapper--bordered {
  border-color: #F0F0F0;
}
.shimmer-item {
  position: relative;
  overflow: hidden;
  background: #F0F0F0;
}
.shimmer-item::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.6) 50%, rgba(255, 255, 255, 0) 100%);
  animation: shimmerMove 1.4s linear infinite;
}
@keyframes shimmerMove {
  100% {
    transform: translateX(100%);
  }
}
/*# sourceMappingURL=shimmer.css.map */`, "",{"version":3,"sources":["webpack://./shimmer.less","webpack://./wp_components/core/Shimmer/shimmer.less"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,6BAAA;ACDF;ADGE;EACE,qBAAA;ACDJ;ADKA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;ACHF;ADMA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,4BAAA;EACA,wHAAA;EACA,2CAAA;ACJF;ADOA;EACE;IACE,2BAAA;ECLF;AACF;AACA,sCAAsC","sourcesContent":["@import \"../../../less/variables.less\";\n\n.shimmer-wrapper {\n  width: 100%;\n  border: 1px solid transparent;\n  \n  &--bordered {\n    border-color: @shimmer-color;\n  }\n}\n\n.shimmer-item {\n  position: relative;\n  overflow: hidden;\n  background: @shimmer-color;\n}\n\n.shimmer-item::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  transform: translateX(-100%);\n  background: @shimmer-gradient;\n  animation: shimmerMove 1.4s linear infinite;\n}\n\n@keyframes shimmerMove {\n  100% {\n    transform: translateX(100%);\n  }\n}",".shimmer-wrapper {\n  width: 100%;\n  border: 1px solid transparent;\n}\n.shimmer-wrapper--bordered {\n  border-color: #F0F0F0;\n}\n.shimmer-item {\n  position: relative;\n  overflow: hidden;\n  background: #F0F0F0;\n}\n.shimmer-item::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  transform: translateX(-100%);\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.6) 50%, rgba(255, 255, 255, 0) 100%);\n  animation: shimmerMove 1.4s linear infinite;\n}\n@keyframes shimmerMove {\n  100% {\n    transform: translateX(100%);\n  }\n}\n/*# sourceMappingURL=shimmer.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
